export const PAGE_LIMIT = 100;
export const PARAMS_NAME = {
    invalidImpressions: 'Invalid Impressions',
    partnerCost: 'Partner Cost',
    roi: 'ROI',
    roiPercent: 'ROI %',
    wonPercent: 'WON %',
    eCPM: 'eCPM',
    fillRate: 'Fill Rate'
};



// WEBPACK FOOTER //
// ./src/scenes/AdkBannerHourly/config.js